import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.flashAlertButton = document.querySelector('#edit_record > div > div.alert.alert-dismissable.alert-success > button')
    this.flashAlertButton && this.flashAlertButton.click()
  }

  closeModal () {
    const textInput = document.getElementById('phone_number')
    if (textInput.value !== '') {
      const closeButton = document.querySelector('#send-mail > div > div.modal-header > button')

      const timer = setInterval(() => {
        console.log('call')
        if (document.querySelector('#edit_record > div > div.alert.alert-dismissable.alert-success > button')) {
          closeButton.click()
          clearInterval(timer)
        }
      }, 1000)
    }
  }
}
